export default "__VITE_ASSET__BuhD8oD$__"